import {
  DashboardStatCard,
  type DashboardStatTone,
} from "@/modules/dashboard/presentation/ui/DashboardStatCard";
import { CompactMoneyAmount } from "@/shared/ui/CompactMoneyAmount";
import { cn } from "@devhop/ui";
import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";

export type { DashboardStatTone };

export function reportSummaryCount(value: number): string {
  return value.toLocaleString("lo-LA");
}

type ReportSummaryStatGridProps = {
  children: ReactNode;
  columns?: 2 | 3 | 4 | 5 | 6;
  className?: string;
};

const gridByColumns = {
  2: "grid grid-cols-2 items-start gap-4",
  3: "grid grid-cols-2 items-start gap-4 lg:grid-cols-3",
  4: "grid grid-cols-2 items-start gap-4 lg:grid-cols-4",
  5: "grid grid-cols-2 items-start gap-4 md:grid-cols-3 xl:grid-cols-5",
  6: "grid grid-cols-2 items-start gap-4 md:grid-cols-3 xl:grid-cols-3",
} as const;

export function ReportSummaryStatGrid({
  children,
  columns = 4,
  className,
}: ReportSummaryStatGridProps) {
  return (
    <div className={cn(gridByColumns[columns], "mb-6", className)}>
      {children}
    </div>
  );
}

type ReportSummaryStatCardProps = {
  title: string;
  icon: LucideIcon;
  isLoading: boolean;
  tone?: DashboardStatTone;
  value?: ReactNode;
  amountKip?: number;
  className?: string;
};

export function ReportSummaryStatCard({
  title,
  icon,
  isLoading,
  tone = "revenue",
  value,
  amountKip,
  className,
}: ReportSummaryStatCardProps) {
  const body =
    value ??
    (amountKip !== undefined ? (
      <CompactMoneyAmount amount={amountKip} />
    ) : (
      "—"
    ));

  return (
    <DashboardStatCard
      title={title}
      icon={icon}
      isLoading={isLoading}
      tone={tone}
      value={body}
      className={className}
    />
  );
}
